var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { Component } from "react";
import { injectIntl } from "@irati/utils/lang";
import { connect } from "@irati/store";
import AuthActions from "@irati/auth/store/actions/AuthActions";
import Loading from "@irati/ui/src/Loading";
import brandingService from "@irati/brand/services/branding";
import adminTracking from "@irati-tracking/admin";
import authentication from "@irati/auth";
import EditWelcomeEmailContent from "./Content";
import SuccessWithBackLink from "../../SuccessWithBackLink";
var welcomeEmailMaxLength = 650;
var WELCOME_EMAIL_KEY = "admin.components.welcomeEmail.default";
var WelcomeEmail = /** @class */ (function (_super) {
    __extends(WelcomeEmail, _super);
    function WelcomeEmail(props) {
        var _this = _super.call(this, props) || this;
        _this.defaultState = function () {
            return {
                saved: false,
                saving: null,
                show: false,
                welcomeEmail: ""
            };
        };
        _this.getWelcomeEmail = function () {
            return brandingService.get({ fetchPolicy: "network-only" }).then(function (branding) {
                _this.setState({ welcomeEmail: branding.welcomeEmail || _this.props.formatMessage({ id: WELCOME_EMAIL_KEY }) });
            });
        };
        _this.handleWelcomeEmailChange = function (e) {
            _this.setState({ welcomeEmail: e || "" });
        };
        _this.useDefault = function () {
            _this.setState({ welcomeEmail: "" }, function () {
                _this.saveWelcomeEmail();
            });
        };
        _this.saveWelcomeEmail = function () {
            if (_this.state.welcomeEmail.length > welcomeEmailMaxLength) {
                return;
            }
            var userTenant = authentication.userTenant();
            var data = {
                businessId: userTenant.uuid,
                teamId: userTenant.rootTeamId,
                welcomeEmail: _this.state.welcomeEmail
            };
            var saving = brandingService.update(data).then(function (brandData) { return __awaiter(_this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    this.setState({ saved: true });
                    setTimeout(function () {
                        _this.setState(function () { return (__assign(__assign({}, _this.defaultState()), { welcomeEmail: brandData.welcomeEmail })); });
                        _this.props.updateTenant();
                    }, 2000);
                    return [2 /*return*/];
                });
            }); });
            adminTracking.updateWelcomeEmail();
            _this.setState({ saving: saving });
        };
        _this.state = _this.defaultState();
        return _this;
    }
    WelcomeEmail.prototype.componentDidMount = function () {
        this.getWelcomeEmail();
    };
    WelcomeEmail.prototype.getSuccessMessage = function () {
        var formatMessage = this.props.formatMessage;
        return this.state.welcomeEmail === ""
            ? formatMessage({ id: "admin.components.welcomeEmail.sendWelcomeEmail" })
            : formatMessage({ id: "admin.components.welcomeEmail.updatedWelcomeEmail" });
    };
    WelcomeEmail.prototype.render = function () {
        var _this = this;
        var _a = this.state, welcomeEmail = _a.welcomeEmail, saving = _a.saving, saved = _a.saved;
        return (React.createElement(Loading, { load: saving }, saved ?
            React.createElement(SuccessWithBackLink, { message: this.getSuccessMessage(), onClick: function () { return _this.setState({ saved: false }); } })
            :
                (React.createElement(EditWelcomeEmailContent, { welcomeEmail: welcomeEmail, welcomeEmailMaxLength: welcomeEmailMaxLength, handleWelcomeEmailChange: this.handleWelcomeEmailChange, useDefault: this.useDefault, saveWelcomeEmail: this.saveWelcomeEmail }))));
    };
    return WelcomeEmail;
}(Component));
var mapDispatchToProps = function (dispatch) {
    return {
        updateTenant: function () { return dispatch(AuthActions.updateTenant()); }
    };
};
export default injectIntl(connect(null, mapDispatchToProps)(WelcomeEmail), { withRef: true });
